/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_OkInputs */

const en_embed_captions_ok = /** @type {(inputs: Embed_Captions_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const fr_embed_captions_ok = /** @type {(inputs: Embed_Captions_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const de_embed_captions_ok = /** @type {(inputs: Embed_Captions_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const it_embed_captions_ok = /** @type {(inputs: Embed_Captions_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ru_embed_captions_ok = /** @type {(inputs: Embed_Captions_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ХОРОШО`)
};

const es_embed_captions_ok = /** @type {(inputs: Embed_Captions_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DE ACUERDO`)
};

const zh_cn2_embed_captions_ok = /** @type {(inputs: Embed_Captions_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好的`)
};

const ja_embed_captions_ok = /** @type {(inputs: Embed_Captions_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`わかりました`)
};

const hi_embed_captions_ok = /** @type {(inputs: Embed_Captions_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक है`)
};

const pt_pt2_embed_captions_ok = /** @type {(inputs: Embed_Captions_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

/**
* | output |
* | --- |
* | "OK" |
*
* @param {Embed_Captions_OkInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_ok = /** @type {((inputs?: Embed_Captions_OkInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_OkInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_ok(inputs)
	if (locale === "de") return de_embed_captions_ok(inputs)
	if (locale === "it") return it_embed_captions_ok(inputs)
	if (locale === "ru") return ru_embed_captions_ok(inputs)
	if (locale === "es") return es_embed_captions_ok(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_ok(inputs)
	if (locale === "ja") return ja_embed_captions_ok(inputs)
	if (locale === "hi") return hi_embed_captions_ok(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_ok(inputs)
	return en_embed_captions_ok(inputs)
});